import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import DrawerMainContent from './DrawerMainContent';
import SideDrawer from '../Drawer/SideDrawer';
import RightSideDrawer from "../Drawer/RightSideDrawer";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'auto',
    height: '100vh',
    display: 'flex',
    background: theme.palette.background.default,
    color: theme.palette.text.secondary
  },
});

const ViewWithDrawer = (props) => {
  const {
    classes, drawerItems, children, padding, mainContentPadding, rightDrawerItems, collapseLeftDrawer
  } = props;
  return (
    <div className={classes.root}>
      <SideDrawer padding={padding} collapseLeftDrawer={collapseLeftDrawer}>
        {drawerItems}
      </SideDrawer>
      <DrawerMainContent padding={mainContentPadding}>
        {children}
      </DrawerMainContent>
      {rightDrawerItems && (
        <RightSideDrawer padding={padding}>
          {rightDrawerItems}
        </RightSideDrawer>
      )}
    </div>
  );
};

ViewWithDrawer.defaultProps = {
  drawerItems: null,
  padding: true,
  mainContentPadding: true
};

ViewWithDrawer.propTypes = {
  drawerItems: PropTypes.instanceOf(Object),
  children: PropTypes.instanceOf(Object).isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
  padding: PropTypes.bool,
  mainContentPadding: PropTypes.bool
};

export default withStyles(styles)(ViewWithDrawer);
